import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {invitationBgm, invitationBgms} = api



/**
 * 查找邀请函背景音乐
 */
export async function findInvitationBgm(params) {
    return request({url: invitationBgm, method: 'get', data: params,})
}

/**
 * 创建邀请函背景音乐
 */
export async function createInvitationBgm(params) {
    return request({url: invitationBgms, method: 'post', data: params,})
}

/**
 * 更新邀请函背景音乐
 */
export async function updateInvitationBgm(params) {
    return request({url: invitationBgm, method: 'put', data: params,})
}

/**
 * 删除邀请函背景音乐
 */
export async function deleteInvitationBgm(params) {
    return request({url: invitationBgm, method: 'delete', data: params,})
}


/**
 * 查找邀请函背景音乐列表
 */
export async function findInvitationBgms(params) {
    return request({url: invitationBgms, method: 'get', data: params,})
}

/**
 * 删除邀请函背景音乐
 */
export async function deleteInvitationBgms(params) {
    return request({url: invitationBgms, method: 'delete', data: params,})
}



// WEBPACK FOOTER //
// ./src/services/invitationBgm.js